import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

const projects = [
  {
    tag: "North Sea · 2024",
    title: "Platform Module Exchange",
    img: "https://images.unsplash.com/photo-1690508313456-bf8c851e8319?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxvZmZzaG9yZSUyMGNyYW5lJTIwb2NlYW4lMjBtYWNoaW5lcnl8ZW58MHx8fHwxNzg1NTI4MDk3fDA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-8",
  },
  {
    tag: "Rigging",
    title: "Wire & Sling Inspection",
    img: "https://images.unsplash.com/photo-1644238017851-21f15062c213?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxzdGVlbCUyMGNhYmxlJTIwd2lyZSUyMHJvcGUlMjBoZWF2eXxlbnwwfHx8fDE3ODU1MjgxMDh8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-4",
  },
  {
    tag: "Fabrication Yard",
    title: "Heavy Skid & Load-Out",
    img: "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwc3RlZWwlMjBoZWF2eSUyMGxpZnQlMjBlbmdpbmVlcmluZ3xlbnwwfHx8fDE3ODU1MjgwOTd8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-4",
  },
  {
    tag: "Gulf · 2023",
    title: "Supply Vessel Deck Ops",
    img: "https://images.unsplash.com/photo-1749073668528-38ab64575f5d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxvZmZzaG9yZSUyMGNyYW5lJTIwb2NlYW4lMjBtYWNoaW5lcnl8ZW58MHx8fHwxNzg1NTI4MDk3fDA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-8",
  },
];

const Card = ({ p, i }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <Reveal
      delay={(i % 2) * 0.1}
      data-testid={`project-${i}`}
      className={`group relative overflow-hidden border border-white/10 ${p.span}`}
    >
      <div ref={ref} className="relative h-[300px] md:h-[440px] overflow-hidden">
        <motion.img
          style={{ y }}
          src={p.img}
          alt={p.title}
          className="h-[116%] w-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050B14] via-transparent to-transparent" />
      </div>
      <div className="absolute bottom-0 left-0 p-6 md:p-8">
        <span className="font-mono text-xs tracking-[0.2em] uppercase text-accent block mb-2">
          {p.tag}
        </span>
        <h3 className="font-display text-2xl md:text-3xl tracking-tight">{p.title}</h3>
      </div>
    </Reveal>
  );
};

export const Gallery = () => (
  <section
    id="fleet"
    data-testid="fleet-section"
    className="w-full px-6 md:px-12 py-24 md:py-40 border-t border-white/10"
  >
    <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16 md:mb-20">
      <Reveal className="md:col-span-3">
        <span className="font-mono text-xs tracking-[0.25em] uppercase text-accent">
          [ 003 — Field Record ]
        </span>
      </Reveal>
      <Reveal className="md:col-span-9" delay={0.1}>
        <h2 className="font-display text-5xl md:text-7xl leading-[0.9] tracking-tight">
          Steel, sea<br />
          <span className="text-[#64748B]">and hard hours.</span>
        </h2>
      </Reveal>
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
      {projects.map((p, i) => (
        <Card key={i} p={p} i={i} />
      ))}
    </div>
  </section>
);
